var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconCards = function SvgIconCards(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.833
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11.917 2.75H4.583c-1.012 0-1.833.82-1.833 1.833V16.5c0 1.012.82 1.833 1.833 1.833h7.334c1.012 0 1.833-.82 1.833-1.833V4.583c0-1.012-.82-1.833-1.833-1.833"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m13.75 4.583 5.5.917-1.833 14.667-9.167-.917"
  }))));
};
export default SvgIconCards;